import { Identifiable, Project, ProjectConfiguration } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function attributeToProjectConfiguration(
  attribute: string,
): ProjectConfiguration {
  const keys = attribute.split(",");

  return {
    isSynthesisEnabled: !keys.find((key) => key === "Synthesis"),
    isListsListEnabled: !keys.find((key) => key === "ListsList"),
    isBoardEnabled: !keys.find((key) => key === "Board"),
    isGanttEnabled: !keys.find((key) => key === "Gantt"),
    areTimeSheetsEnabled: !keys.find((key) => key === "TimeSheets"),
    areDiscussionsEnabled: !keys.find((key) => key === "Discussions"),
    areDocumentsEnabled: !keys.find((key) => key === "Documents"),
    isBudgetEnabled: !keys.find((key) => key === "Budget"),
    isCalendarEnabled: !keys.find((key) => key === "Calendar"),
    areReportsEnabled: !keys.find((key) => key === "Reports"),
  };
}

function getProjectConfiguration(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Identifiable<Project>>({
        endpoint: `/projects/${project.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ attributes }) =>
        attributeToProjectConfiguration(attributes.toolsConfig || ""),
      );
}

export { getProjectConfiguration };
